export type ChatContentProps = {
  children: React.ReactNode
}

export function ChatContent({ children }: ChatContentProps) {
  return (
    <section
      className="flex min-h-0 flex-1 flex-col items-center overflow-y-auto overscroll-contain pt-14"
      data-testid="chat-content"
    >
      <section
        className="flex w-full max-w-[877px] flex-col gap-6 px-2"
        style={{ paddingBottom: "var(--chat-footer-height, 0px)" }}
      >
        {children}
      </section>
    </section>
  )
}
